export const CAREER_ADD_REQUEST = "CAREER_ADD_REQUEST";
export const CAREER_ADD_SUCCESS = "CAREER_ADD_SUCCESS";
export const CAREER_ADD_FAIL = "CAREER_ADD_FAIL";
